<div class="container">
  @if (activities$ | async; as activities) {
    <shared-activity [relatedTo]="relatedTo" [activities]="activities"></shared-activity>
  } @else {
    <div class="container__loading">
      @for (item of [].constructor(6); track $index) {
        <div class="container__loading__item">
          <ts-skeleton diameter="50" mode="circle" />
          <div class="container__loading__item__rect">
            <ts-skeleton height="10" radius="0" />
            <ts-skeleton height="10" radius="0" class="small" />
            <ts-skeleton height="10" radius="0" class="medium" />
            <ts-skeleton height="10" radius="0" class="big" />
          </div>
        </div>
      }
    </div>
  }
</div>
